import React from 'react';
import { CheckboxGroup, TextCheckbox, TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import AudienceDetails from '../../AudienceDetails/AudienceDetails';
import { useMyAudienceDropdownOption } from './useMyAudienceDropdownOption';
import styles from './myAudiencesDropDownOptionCheckbox.module.scss';

const sizeTooltip = (
    <Tooltip position={TOOLTIP_POSITION.BOTTOM_END} arrow duration={0} delay={0}>
        <FormattedMessage
            id="campaign.editor.targeting.my.audiences.combined.audience.size.tooltip"
            defaultMessage="Size will be populated in 24 hours"
        />
    </Tooltip>
);

export const MyAudienceDropDownOptionCheckbox = ({
    data,
    selectProps: { inputValue },
    selectedSegments,
    disabledTooltip,
}) => {
    const { id, label, audienceType, isDisabled, externalId } = data;
    const { audienceSize: size } = useMyAudienceDropdownOption(data);

    return (
        <div className={styles['label']}>
            <CheckboxGroup selectedValues={selectedSegments} disabled={isDisabled}>
                <TextCheckbox
                    label={`${id}-checkbox`}
                    value={id}
                    labelClassName={styles['label']}
                    inputClassName={styles['checkbox']}
                    title={
                        <AudienceDetails
                            name={label}
                            highLightText={inputValue}
                            externalId={externalId}
                            detail={audienceType}
                            size={size}
                            minSize={100}
                            sizeTooltip={audienceType === 'COMBINED_AUDIENCE' && sizeTooltip}
                            disabled={isDisabled}
                            disabledTooltip={disabledTooltip}
                            isCheckbox={true}
                        />
                    }
                    disabled={isDisabled}
                    selectedValues={selectedSegments}
                />
            </CheckboxGroup>
        </div>
    );
};
